import { createSelector } from '@ngrx/store';
import { ILayoutState } from '@layout/state/layout.reducer';
import { IAssigneeOrganization } from '@app/shared/interfaces/selectable-options.interfaces';
import { getCurrentUser } from '@auth/state/auth.selectors';

export const selectLayoutState = (state): ILayoutState => state.layout.main;

export const isNavSidebarCollapsed = createSelector(
	selectLayoutState,
	layout => layout.navSidebarCollapsed
);

export const assigneeList = createSelector(
	selectLayoutState,
	layout => layout.selectableOptions?.assignees
);

export const currentUserOrganization = createSelector(
	getCurrentUser,
	assigneeList,
	(user, assignees) => {
		if (!user?.organization?.psId || !assignees) {
			return null;
		}
		return assignees.find(org => org.psId === user.organization.psId) || null;
	}
);

export const usersTeamById = (teamId: string) =>
	createSelector(selectLayoutState, layout => {
		return findTeamInOrganizationsById(layout.selectableOptions?.assignees, teamId);
	});

function findTeamInOrganizationsById(
	organizations: IAssigneeOrganization[],
	teamPsId: string
) {
	if (!organizations) {
		return;
	}

	for (const organization of organizations) {
		const foundedTeam = organization.teams.find(team => team.psId === teamPsId);
		if (foundedTeam) {
			return foundedTeam;
		}
	}
}

export const assigneeListRequestOngoing = createSelector(
	selectLayoutState,
	layout => layout.assigneeListRequestOngoing
);

export const roomTypesList = createSelector(
	selectLayoutState,
	layout => layout.selectableOptions?.roomTypes
);

export const organizationTypes = createSelector(
	selectLayoutState,
	layout => layout.selectableOptions?.organizationTypes
);

export const buildingsList = createSelector(selectLayoutState, layout => {
	if (layout.selectableOptions) {
		return layout.selectableOptions.buildings;
	}
});

export const rightSideBarNavigation = createSelector(
	selectLayoutState,
	(layout: ILayoutState) => {
		return layout.rightSideBar;
	}
);

export const rightSidebarComponentContext = createSelector(
	selectLayoutState,
	layout => layout.rightSideBar.componentContext
);

export const isAiChatOpened = createSelector(
	selectLayoutState,
	layout => layout.aiChatOpened
);

export const breadcrumbConfiguration = createSelector(
	selectLayoutState,
	layout => layout.breadcrumbConfiguration
);

export const breadcrumbMenuConfiguration = createSelector(
	selectLayoutState,
	layout => layout.breadcrumbMenuConfig
);
